<template>
    <div class="search-user-container">
        <div class="container-list" :style="{  height: containerHeight }">
            <div class="search-user-header">
                <div  class="input-container">
                    <input
                        :value="searchOrigin" 
                        :placeholder="searchMessage" 
                        class="input-transfer"
                        @input="$emit('input', $event.target.value)" 
                    />
                    <ui-user-search-icon class="icon-input" :fill="iconColor"/>
                    <div v-if="loading" class="loader">
                        <ui-load-indicator bg-color="#C9C9E8" color="#0091FF" :h="29" :stroke="8" />
                    </div>
                </div>
                <slot name="originAction" />
            </div>
            <perfect-scrollbar>
                <slot name="sourceList" class="list scroll-color-primary"/>
            </perfect-scrollbar>
        </div>
    </div>
</template>


<script>
import { uiUserSearchIcon } from '@/components/ui-icons';
import { uiLoadIndicator } from '@/components/ui'

export default {
    name: 'ui-search-user',
    components: {
        uiUserSearchIcon,
        uiLoadIndicator
    },
    model: {
        prop: 'searchOrigin',
        event: 'input'
    },
    props: {
        searchOrigin: {
            type: String,
            default: ''
        },
        searchMessage: {
            type: String,
            default: ''
        },
        containerHeight:{
            type: String,
            default: '100%'
        },
        loading: {
            type: Boolean,
            default: false
        }

    },
    
    data() {
        return {
        }
    },
    computed: {
        iconColor() {
            return this.searchOrigin?.trim().length > 0 ? '#008AF2' : '#7F97AF';
        }
    },
    methods: {
        onOriginInput(event) {
            this.$emit('update:searchOrigin', event.target.value);
        },
        onTargetInput(event) {
            this.$emit('update:searchTarget', event.target.value);
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
